





































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Children } from './types';
import ButtonCanRequest from '@/presets/button/can-request';
import {
  Breadcrumbs as BreadcrumbsLayout,
  Extra as ExtraLayout,
} from '@/components/layout';
import {
  OrderHeader,
  OrderInfo,
  OrderWrapper,
  OrderDatepicker,
  OrderChildren,
  OrderSpinner,
  OrderMessage,
  OrderAddChildren,
} from '@/components/orders';
import { ITimePeriodsByDatesItem } from '@/pages/activities/card/types';
import { Select as FormSelect, Input as FormInput } from '@/components/form';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import {
  ACTION_FETCH,
  SEND_ACTIVITY_ORDER,
  STORE_MODULE_NAME,
} from '@/pages/activities/card/const';
import { mapActions } from 'vuex';
const actions = mapActions(STORE_MODULE_NAME, [
  ACTION_FETCH,
  SEND_ACTIVITY_ORDER,
]);
const send = actions[SEND_ACTIVITY_ORDER];

@Component({
  components: {
    AppButtonNew,
    OrderSpinner,
    BreadcrumbsLayout,
    ButtonCanRequest,
    OrderHeader,
    OrderInfo,
    OrderWrapper,
    OrderDatepicker,
    OrderChildren,
    OrderMessage,
    OrderAddChildren,
    FormSelect,
    FormInput,
  },
})
export default class PagesOrderActivites extends Vue {
  @Prop({ type: Function })
  nextStep: Function;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: String, default: '' })
  address: string;

  @Prop({ type: String, default: '' })
  membersOfActivity: string;

  @Prop({ type: Boolean, default: false })
  isChildrenInOrder: boolean;

  @Prop({ type: Boolean, default: false })
  isChildrenErrorMessage: boolean;

  @Prop({ type: Array, default: () => [] })
  children: Children;

  @Prop({ type: Array, default: () => [] })
  unselectedChildren: Children;

  @Prop({ type: Boolean, default: false })
  isAddChildError: boolean;

  @Prop({ type: Boolean, default: false })
  hasSending: boolean;

  @Prop({ type: Boolean, default: false })
  hasSent: boolean;

  @Prop({ type: Object, default: null })
  activeDates: any;

  @Prop({ type: Object, default: null })
  disabledDates: any;

  @Prop({ type: Date, required: true })
  dateOrder: Date;

  @Prop({ required: false })
  timeId: number | null;

  @Prop({ type: String, default: null })
  srvErrorMsg: string | null;

  date: Date = this.dateOrder;
  showOrderMessage = false;
  selectedTimeItem: ITimePeriodsByDatesItem | null = null;
  eduLvl: any = '';
  organizationName: '';

  @Watch('date')
  isDateChange(value: Date) {
    this.$emit('dateChanged', value);
  }

  @Watch('hasSent')
  isHasSent(value: boolean) {
    if (value && !this.srvErrorMsg) this.showOrderMessage = value;
  }

  get getOptions() {
    return [
      ...this.$store.state.activityOrderEduLevelDict.map((el: any) => {
        return { value: el.id, text: el.name };
      }),
    ];
  }

  get getImpossibleText() {
    if (this.isChildrenErrorMessage) {
      return undefined;
    }
    return 'Записаться';
  }

  removeChildFromOrder(value: number) {
    this.$emit('removeChildFromOrder', value);
  }

  addCheckedChildren(value: Array<string>) {
    this.$emit('addCheckedChildren', value);
  }
  get timePeriodsByDates() {
    return this.$store.state.activityCard.timePeriodsByDates;
  }

  async onSubmit() {
    const activityId = this.$store.state.activityCard.activity.id;
    const userId = this.$store.getters['user/userId'];
    const data = {
      activity_id: activityId,
      activity_date: this.selectedTimeItem?.startDate,
      organization_name: this.organizationName || undefined,
      students: [
        {
          id: userId,
          edu_level: this.eduLvl ? this.eduLvl : undefined,
        },
      ],
    };
    const payload = {
      data: data,
    };
    try {
      const msg = await send.call(this, payload);
      this.$emit('sendResult', msg);
    } catch (e) {
      this.$emit('sendResult', {
        type: 'error',
      });
    }
    this.nextStep();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/activities/card/order/ActivitesOrder.vue